__turbopack_context__.v({
  "className": "k21uoq_className",
  "variable": "k21uoq_variable",
});
